module.exports = __webpack_public_path__ + "img/itsu-pattern-vertical.ea44ced.svg";